import React, { FC, memo } from 'react';
import logo from 'assets/images/logo-branca.svg';
import banner from 'assets/images/banner.png';
import { Container, Header, Logo, Main, Left, Right, ContainerBody, ContainerFooter } from './styl';
const TemplateAuth: FC<any> = ({ children }) => {
	return (
		<ContainerBody>
			<Container>
				<Header>
					<Logo src={logo} alt="Logo" />
				</Header>
			
				<Main>
					<Left>
						<img src={banner} alt="Imagem" />
					</Left>
			
					<Right>
						{children}
					</Right>

					<ContainerFooter/>
				</Main>
			</Container>			
		</ContainerBody>
	);
};
export default memo(TemplateAuth);
